import BaseParseObject from './BaseParseObject'
import ObservingList from './ObservingList'

'use strict'

export const StaticObservingList = BaseParseObject.extend('StaticObservingList', {
  getNumberOfSkyObjects: function () {
    let count = 0

    if (this.get('skyObjects')) {
      // count the number in skyObjects list
      count = Object.keys(this.get('skyObjects')).length
    }

    return count
  },
  isAGroup: function () {
    return this.get('isAGroup')
  },
  importAsObservinglist: function () {
    const newObservingList = new ObservingList()
    newObservingList.set('title', this.get('title'))
    newObservingList.set('description', this.get('description'))
    newObservingList.set('skyObjects', this.get('skyObjects'))

    return newObservingList.update()
  }
})

export default StaticObservingList
